// extracted by mini-css-extract-plugin
export default {"container":"PJ-z","error":"QJ-z","disabled":"RJ-z","submit":"SJ-z","option":"TJ-z","success":"UJ-z","failure":"VJ-z"};